export default __webpack_public_path__ + "static/media/GroupDesc.8677fe53.png";